var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('router-link',{staticClass:"button is-success",attrs:{"to":{'name':'client-content-strings-create', params: { clientId: _vm.clientId }}}},[_vm._v("Create string")])],1)]),_vm._v(" "),_c('content-string-list',{attrs:{"items":_vm.items,"reload":_vm.reload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/content/strings/list.vue?vue&type=template&id=ad5b388c
// module id = wUxX
// module chunks = 0